'use strict';

angular.module('body-layout', [
    'ui.router',
])
    .provider('BodyLayout', function() {
        var __states = {};

        this.setLayout = function(layout, states) {
            for (var index in states) {
                __states[states[index]] = layout;
            }

            return this;
        };

        this.$get = ['$rootScope', function($rootScope) {
            return {
                update: function(toState) {
                    $rootScope.bodyLayout = __states[toState.name] || null;
                },
            };
        }];
    })
    .run(['$transitions', 'BodyLayout', function($transitions, BodyLayout) {
        $transitions.onSuccess({}, function(transition) {
            BodyLayout.update(transition.to());
        });
    }]);
